import React from "react";

const RulesTitle = () => {
  return (
    <span className="text-base font-bold leading-normal text-themeBlack">
      Kurallar
    </span>
  );
};

export default RulesTitle;
